<template>
  <div class="animate-pulse rounded-xl border border-steel-40 bg-white">
    <div
      class="flex items-center justify-between border-b border-steel-40 px-4 py-2"
    >
      <div class="flex items-center gap-2">
        <div class="h-4 w-4 rounded-full bg-steel-20"></div>
        <div class="h-4 w-20 rounded bg-steel-20"></div>
      </div>
      <div class="h-4 w-36 rounded bg-steel-20"></div>
    </div>

    <div class="flex flex-col gap-3 px-4 py-2">
      <div class="grid grid-cols-4 items-center gap-2">
        <div class="col-span-1 h-4 w-14 rounded bg-steel-20"></div>
        <div class="col-span-3 h-4 w-full rounded bg-steel-20"></div>
      </div>
      <div class="grid grid-cols-4 items-center gap-2">
        <div class="col-span-1 h-4 w-14 rounded bg-steel-20"></div>
        <div class="col-span-3 h-4 w-full rounded bg-steel-20"></div>
      </div>
      <div class="grid grid-cols-4 items-center gap-2">
        <div class="col-span-1 h-4 w-14 rounded bg-steel-20"></div>
        <div class="col-span-3 h-4 w-full rounded bg-steel-20"></div>
      </div>
      <div class="grid grid-cols-4 items-center gap-2">
        <div class="col-span-1 h-4 w-14 rounded bg-steel-20"></div>
        <div class="col-span-3 h-4 w-full rounded bg-steel-20"></div>
      </div>
    </div>

    <div
      class="flex items-center justify-between rounded-b-xl bg-steel-100 px-4 py-2"
    >
      <div class="flex items-center gap-2">
        <div class="h-4 w-6 rounded-full bg-steel-20"></div>
        <div class="h-4 w-24 rounded bg-steel-20"></div>
      </div>
      <div class="flex items-center gap-2">
        <div class="h-4 w-6 rounded-full bg-steel-20"></div>
        <div class="h-4 w-24 rounded bg-steel-20"></div>
      </div>
    </div>
  </div>
</template>
